module.exports = __webpack_public_path__ + "static/media/covernote-focused.f848c077.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/covernote-focused.svg
// module id = 1229
// module chunks = 0